import { render, staticRenderFns } from "./AsignacionesEquipoSubsede.vue?vue&type=template&id=70038ac3&scoped=true"
import script from "./AsignacionesEquipoSubsede.vue?vue&type=script&lang=js"
export * from "./AsignacionesEquipoSubsede.vue?vue&type=script&lang=js"
import style0 from "./AsignacionesEquipoSubsede.vue?vue&type=style&index=0&id=70038ac3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70038ac3",
  null
  
)

export default component.exports